import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AccountsContextService } from 'src/app/accounts/account-context.service';
import { WhiteLabelService } from 'src/app/white-label/white-label.service';

@Component({
  selector: 'app-logo',
  templateUrl: 'logo.component.html',
  styleUrls: ['logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  @Input()
  public isSmall: boolean = true;

  public readonly contextService: AccountsContextService;
  public readonly whiteLabelService: WhiteLabelService;

  constructor() {
    this.contextService = inject(AccountsContextService);
    this.whiteLabelService = inject(WhiteLabelService);
  }
}
